module.exports = __webpack_public_path__ + "6afe1aad039eeb8c862b6738690ccead.svg";